import { z } from "zod";
import { workLineSchema } from "./mobiles";

const roleEnum = z.enum(["admin", "operator", "fleet_manager", "driver"]);

export const createUserSchema = z.object({
  email: z.string().email("Email inválido"),
  firstName: z.string().min(1, "El nombre es requerido"),
  lastName: z.string().min(1, "El apellido es requerido"),
  password: z.string().min(8, "La contraseña debe tener al menos 8 caracteres"),
  role: roleEnum,
  phone: z.string().optional(),
  isActive: z.boolean().optional().default(true),
  workLines: z.array(workLineSchema).nullable().optional(),
}).refine(
  (d) => d.role !== "driver" || !d.workLines?.length,
  { message: "Los choferes no pueden tener líneas de trabajo asignadas", path: ["workLines"] }
);

export const updateUserSchema = z.object({
  firstName: z.string().min(1).optional(),
  lastName: z.string().min(1).optional(),
  email: z.string().email().optional(),
  role: roleEnum.optional(),
  phone: z.string().nullable().optional(),
  isActive: z.boolean().optional(),
  password: z.string().min(8).optional(),
  workLines: z.array(workLineSchema).nullable().optional(),
}).refine(
  (d) => d.role !== "driver" || !d.workLines?.length,
  { message: "Los choferes no pueden tener líneas de trabajo asignadas", path: ["workLines"] }
);

export type CreateUserInput = z.infer<typeof createUserSchema>;
export type UpdateUserInput = z.infer<typeof updateUserSchema>;
